"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

/*
 *  component/form/Input.tsx
 *  Project-Lego
 *
 *  This component serves as a 1:1 direct replacement for <input>, but with more
 *  sane handling of numerical input
 *
 *  Created by Lucas Liepert on 7/22/20.
 *  Copyright © 2020-present ContextLogic Inc. All rights reserved.
 */
var _default = (0, _mobxReact.observer)( /*#__PURE__*/_react["default"].forwardRef(function (propsOrganic, ref) {
  var onChangeProp = propsOrganic.onChange,
      valueProp = propsOrganic.value,
      typeProp = propsOrganic.type,
      props = (0, _objectWithoutProperties2["default"])(propsOrganic, ["onChange", "value", "type"]);

  var _useState = (0, _react.useState)(valueProp),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  (0, _react.useEffect)(function () {
    setValue(valueProp);
  }, [valueProp]);

  var onChange = function onChange(e) {
    var target = e.target;
    var newValue = target.value; // if type is number and a user inputs a NaN (including of the form
    // "1.1."), we want to disregard the input. However, if the input
    // is "-" (negative sign), we keep it.

    if (typeProp == "number" && Number.isNaN(Number(newValue)) && newValue !== "-") {
      return;
    } // if type is number and we receive input of the form "1.", we ignore it
    // if we don't, useFloat(newValue) = 1, which is often fed into the state
    // controlling the input, serving to make it impossible to input decimals
    // (mimics numeric behaviour in Chrome)


    if (typeProp == "number" && /-?[0-9]\./.test(newValue.slice(-2))) {
      setValue(newValue);
      return;
    } // if type is number and we receive input that is equivalent to the
    // previous input, we disregard the input. This allows us to type
    // something like `10.10` without useFloat removing the trailing 0,
    // which is required for typing something like `10.101`
    // (lliepert, code also covers above case but leaving seperate for
    // easy revertability if this new feature breaks anything)


    if (typeProp == "number" && Number(newValue) == value) {
      setValue(newValue);

      if (newValue === "0" && value === "" || newValue === "" && value === "0") {
        onChangeProp && onChangeProp(e);
      }

      return;
    } // else propegate event back to caller as if we don't exist


    setValue(newValue); // setValue required for IME

    onChangeProp && onChangeProp(e);
  }; // we replace type="number" with type="text" to prevent the case where a
  // user inputs a NaN (i.e. 1.1.) and the HTML spec requires "" be passed
  // back this results in inconsistent state between the value returned and
  // the value displayed on the screen
  // inputmode="numeric" provides the numeric keyboard on supporting devices


  var type = typeProp == "number" ? "text" : typeProp;
  return /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    ref: ref,
    value: value,
    onChange: onChange,
    type: type
  }, props));
}));

exports["default"] = _default;